<template>
    <div class="help">
        <img loading="lazy" v-lazy="require('../../assets/images/yy/help.png')" alt="" srcset="">
        <div class="box">
           <div class="left">
                <ul>
                    <li :class="index == actIndex? 'activity' :''" v-for='(item,index) in list' :key="index" @click="tabCheck(index)"><p></p>{{item.name}}</li>
                </ul>
           </div>
           <div class="right">
               <!-- 关于澳门金沙 -->
               <div class="list" v-show="actIndex == 0">
                   <AboutTenbo/>
               </div>
                <!-- 博彩责任 -->
               <div class="list" v-show="actIndex == 1">
                   <responsibility/>
               </div>
                <!-- 规则与声明 -->
               <div class="list" v-show="actIndex == 2">
                   <declarations/>
               </div>
               <!-- 牌照展示 -->
               <div class="list" v-show="actIndex == 3">
                   <Licensedisplay/>
               </div>
                 <!-- 常见问题 -->
               <div class="list" v-show="actIndex == 4">
                   <commonProblem/>
               </div>
               <!-- 联系我们 -->
                <div class="list" v-show="actIndex == 5">
                   <contactUs/>
               </div>
               <!-- 防劫持帮助 -->
               <div class="list" v-show="actIndex == 6">
                   <hijackingHelp/>
               </div>
               <!-- 存款演示 -->
                <div class="list"  v-show="actIndex == 7">
                   <DepositDemo/>
               </div>
               <!-- 存款演示 -->
                <div class="list"  v-show="actIndex == 8">
                   <WithdrawDemo />
               </div>
           </div>
        </div>
    </div>
</template>
<script>
import contactUs from './contactUs.vue'
import hijackingHelp from './hijackingHelp.vue'
import DepositDemo from './DepositDemo.vue'
import Licensedisplay from './Licensedisplay.vue'
import AboutTenbo from './AboutTenbo.vue'
import declarations from './declarations.vue'
import responsibility from './responsibility.vue'
import commonProblem from './commonProblem.vue'
import WithdrawDemo from './withdrawDemo.vue'
export default {
    components:{
        hijackingHelp,
        DepositDemo,
        contactUs,
        Licensedisplay,
        AboutTenbo,
        declarations,
        responsibility,
        commonProblem,
        WithdrawDemo
    },
    data(){
        return {
            list:[
                {
                    name: this.$t('help.titel1'),
                    index:0
                },{
                    name:this.$t('help.name20'),
                    index:1
                },{
                    name:this.$t('help.titel88'),
                    index:2
                },{
                    name:this.$t('help.name21'),
                    index:3
                },{
                    name:this.$t('help.titel11'),
                    index:4
                },{
                    name:this.$t('help.titel78'),
                    index:5
                },{
                    name:this.$t('help.name22'),
                    index:6
                },{
                    name:this.$t('help.name23'),
                    index:7
                },
                {
                    name:this.$t('help.name233'),
                    index:8
                },

            ],
            actIndex:0
        }
    },
    created(){
        if(this.$route.query.tab){
            this.actIndex = this.$route.query.tab;
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
        tabCheck(index){
            this.actIndex = index;
        }
    },
    watch:{
        "$i18n.locale"(n) {
            if (n) {
                this.list = [
                    {
                        name: this.$t('help.titel1'),
                        index:0
                    },{
                        name:this.$t('help.name20'),
                        index:1
                    },{
                        name:this.$t('help.titel88'),
                        index:2
                    },{
                        name:this.$t('help.name21'),
                        index:3
                    },{
                        name:this.$t('help.titel11'),
                        index:4
                    },{
                        name:this.$t('help.titel78'),
                        index:5
                    },{
                        name:this.$t('help.name22'),
                        index:6
                    },{
                        name:this.$t('help.name23'),
                        index:7
                    },
                    {
                        name:this.$t('help.name233'),
                        index:8
                    },

                ]
            }
        },
        '$route.query'(val){
            this.actIndex = val.tab
        }
    }
}
</script>
<style scoped lang='scss'>
    .help{
        width: 12rem;
        min-width: 1000px;
        margin: 0.2rem auto 0.2rem;
        img{
            margin-bottom: 15px;
            width: 100%;
        }
        .box{
            background: #fff;
            display: flex;
            .left{
                width: 240px;
                margin-right: 20px;
                background: #fff;
                min-height: 600px;
                overflow: hidden;
                li{
                    float: left;
                    width: 100%;
                    height: 60px;
                    line-height: 60px;
                    font-size: 15px;
                    border-bottom: 2px solid #f2f2f2;
                    text-indent: 25px;
                    position: relative;
                    cursor: pointer;
                    color: #333;
                    p{
                        width: 0;
                        height: 100%;
                        position: absolute;
                        background-color: #ff4b4b;
                    }
                }
                .activity{
                    color: #fff;
                    font-weight: 600;
                    background: #ff4b4b;
                }
                li:hover p{
                    width: 5px;
                    transition: width 0.2s;
                }
            }
            .right{
                flex: 1;
                .list{
                    float: left;
                    width: 100%;
                }
            }
        }
    }
</style>